$('.1multicolumn-list').slick({
   responsive: [
      {
        breakpoint: 5000,
        settings: "unslick"
      },
      
      {
        breakpoint: 576,
        settings: {
          autoplay:true,
          autosplayspeed:3000,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});
$(document).ready(function() {
   var slideCount = $('.custom_multicolumn_content_layout').children().length;
  if ($(window).width() > 769 && slideCount > 4) {
     $('.custom_multicolumn_content_layout').slick({
      responsive: [
        {
          breakpoint: 5000,
          settings: {
            arrows: false,
            dots:true,
           autoplay:true,
            autosplayspeed:3000,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
        ]
       });
  }
  if ($(window).width() <= 768) {
  $('.custom_multicolumn_content_layout').slick({
    responsive: [
      // {
      //     breakpoint: 5000,
      //     settings: "unslick"
      //   },
      {
           breakpoint: 769,
        settings: {
          arrows: false,
          dots:true,
           autoplay:true,
            autosplayspeed:3000,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          arrows: false,
          dots:true,
           autoplay:true,
            autosplayspeed:3000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        }
      }
    ]
  });
  }
});
  $(document).ready(function(){
    $('ul.shopify-tabs > li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $(this).parent().find('li').removeClass('current');
      $('.shopify-tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })
  });

  $(document).ready(function() {
    $('.header__inline-menu .list-menu  header-menu .mega-menu summary').click(function() {
      let attr = $.parseJSON($(this).attr('aria-expanded'));
      if(attr == true) {
        $('sticky-header').addClass('custom-header-background');
      }
      else {
        $('sticky-header').removeClass('custom-header-background');
      }
    });
  });

$(document).on('click', function() {
  let active_attr = $.parseJSON($('.header__inline-menu .list-menu  header-menu .mega-menu summary').attr('aria-expanded'));
   if(active_attr == false) {
        $('sticky-header').removeClass('custom-header-background');
      }
});
